import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addState, deleteState, fetchStateList, updateState } from "./StateListAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchStateListAsync = createAsyncThunk(
  "StateList/fetch",
  async (page, { rejectWithValue }) => {
    try {
      const data = await fetchStateList(page);

      const resp = data.response;
      // console.log("data's response", data.response)

      return {
        states: resp.data,  // The array of job data
        totalStates: resp.total,  
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const deleteStateListAsync = createAsyncThunk(
  'StateList/delete',
  async (uuid, { rejectWithValue }) => {
    try {
      await deleteState(uuid);
      return uuid; 
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateStateListAsync = createAsyncThunk(
  'StateList/update',
  async ({ uuid, StateData }, { rejectWithValue }) => {
    try {
      const response = await updateState(uuid, StateData);
      // console.log("Response Slice", response)
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addStateListAsync = createAsyncThunk(
  "StateList/add",
  async (newState) => {
    try {
      const data = await addState(newState);
      // console.log("data in slice", data)
      return data;
    } catch (error) {
      console.log("errorL :" , error)
      // return rejectWithValue(error.message);
    }
  }
);

const StateSlice = createSlice({
  name: "State",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStateListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStateListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchStateListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      
      .addCase(addStateListAsync.fulfilled, (state, action) => {
        state.data?.push(action.payload);
      })
      .addCase(addStateListAsync.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateStateListAsync.pending, (state) => {
        state.loading = true;
        // console.log("Loading")
        state.error = null;
      })
      .addCase(updateStateListAsync.fulfilled, (state, action) => {
        state.loading = false;
        // console.log("data", state.data)
        state.data = state.data.map((StateData) =>
            StateData.uuid === action.payload.uuid ? action.payload : StateData
        );
      })
      .addCase(updateStateListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteStateListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteStateListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter(
          (StateData) => StateData.uuid !== action.payload
        );
      })
      .addCase(deleteStateListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});
export const selectState = (state) => state.State.data.states;
export const selectStateTotal = (state) => state.State.data.totalStates;

export default StateSlice.reducer;
